var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: _vm.title,
        visible: _vm.domVisible,
        "custom-class": _vm.dialogClass,
        "close-on-click-modal": false,
        "lock-scroll": false,
        "before-close": _vm.closeDialog
      },
      on: {
        "update:visible": function($event) {
          _vm.domVisible = $event
        }
      }
    },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading.fullscreen",
              value: _vm.loading,
              expression: "loading",
              modifiers: { fullscreen: true }
            }
          ]
        },
        [
          _c(
            "el-form",
            {
              ref: "ruleForm",
              attrs: { model: _vm.ruleForm, rules: _vm.rules }
            },
            [
              _c(
                "el-form-item",
                { staticClass: "login_form_item", attrs: { prop: "userName" } },
                [
                  _c("div", { staticClass: "login_title" }, [
                    _vm._v(_vm._s(_vm.$t("RecipientName")))
                  ]),
                  _vm._v(" "),
                  _c("el-input", {
                    staticClass: "login_ipt",
                    attrs: { placeholder: _vm.$t("verify.RecipientName") },
                    on: {
                      input: function($event) {
                        return _vm.setInput()
                      }
                    },
                    model: {
                      value: _vm.ruleForm.userName,
                      callback: function($$v) {
                        _vm.$set(_vm.ruleForm, "userName", $$v)
                      },
                      expression: "ruleForm.userName"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { staticClass: "login_form_item", attrs: { prop: "mobile" } },
                [
                  _c("div", { staticClass: "login_title" }, [
                    _vm._v(_vm._s(_vm.$t("PhoneNumber")))
                  ]),
                  _vm._v(" "),
                  _c("el-input", {
                    staticClass: "login_ipt",
                    attrs: { placeholder: _vm.$t("verify.PhoneNumber") },
                    on: {
                      input: function($event) {
                        return _vm.setInput()
                      }
                    },
                    model: {
                      value: _vm.ruleForm.mobile,
                      callback: function($$v) {
                        _vm.$set(_vm.ruleForm, "mobile", $$v)
                      },
                      expression: "ruleForm.mobile"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { staticClass: "login_form_item", attrs: { prop: "email" } },
                [
                  _c("div", { staticClass: "login_title" }, [
                    _vm._v(_vm._s(_vm.$t("EmailAddress")))
                  ]),
                  _vm._v(" "),
                  _c("el-input", {
                    staticClass: "login_ipt",
                    attrs: { placeholder: _vm.$t("verify.Email") },
                    model: {
                      value: _vm.ruleForm.email,
                      callback: function($$v) {
                        _vm.$set(_vm.ruleForm, "email", $$v)
                      },
                      expression: "ruleForm.email"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { staticClass: "login_form_item", attrs: { prop: "provice" } },
                [
                  _c("div", { staticClass: "login_title" }, [
                    _vm._v(_vm._s(_vm.$t("Region")))
                  ]),
                  _vm._v(" "),
                  _c("el-cascader", {
                    staticClass: "login_ipt",
                    attrs: {
                      "popper-class": "provinceList",
                      separator: " ",
                      placeholder: _vm.$t("verify.Region"),
                      options: _vm.provinceList
                    },
                    on: { change: _vm.proviceChange },
                    model: {
                      value: _vm.ruleForm.provice,
                      callback: function($$v) {
                        _vm.$set(_vm.ruleForm, "provice", $$v)
                      },
                      expression: "ruleForm.provice"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { staticClass: "login_form_item", attrs: { prop: "address" } },
                [
                  _c("div", { staticClass: "login_title" }, [
                    _vm._v(_vm._s(_vm.$t("StreetAddress")))
                  ]),
                  _vm._v(" "),
                  _c("el-input", {
                    staticClass: "login_ipt",
                    attrs: { placeholder: _vm.$t("verify.StreetAddress") },
                    on: {
                      input: function($event) {
                        return _vm.setInput()
                      }
                    },
                    model: {
                      value: _vm.ruleForm.address,
                      callback: function($$v) {
                        _vm.$set(_vm.ruleForm, "address", $$v)
                      },
                      expression: "ruleForm.address"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "tips" },
                [
                  _c("div", [_vm._v(_vm._s(_vm.$t("MakePrimary")))]),
                  _vm._v(" "),
                  _c("el-switch", {
                    model: {
                      value: _vm.ruleForm.delivery,
                      callback: function($$v) {
                        _vm.$set(_vm.ruleForm, "delivery", $$v)
                      },
                      expression: "ruleForm.delivery"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _vm.isSet ? _c("div", { staticClass: "tips" }) : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "login_btn_between" },
                [
                  _c(
                    "el-button",
                    {
                      staticClass: "login_btn",
                      on: {
                        click: function($event) {
                          return _vm.resetForm("ruleForm")
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("Cancel")))]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      staticClass: "login_btn",
                      attrs: { disabled: _vm.disabled, type: "primary" },
                      on: {
                        click: function($event) {
                          return _vm.submitForm("ruleForm")
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("Confirm")))]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3a2001bd", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3a2001bd","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dialog/address.vue
// module id = null
// module chunks = 